<script setup lang="ts">
import { useTemplateRef, watchEffect } from 'vue';

import { AppButton } from '../button';

const props = defineProps<{
  hasMore: boolean;
  loading?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{ load: [] }>();

const root = useTemplateRef<HTMLElement>('root');

// Кнопка и есть датчик бесконечной прокрутки: показалась на экране — грузим следующую страницу.
// Нажать её можно всегда, если датчик не сработал. Observer срабатывает при пересечении границы:
// если после догрузки кнопка осталась на экране, следующая страница ждёт прокрутки или нажатия.
watchEffect((onCleanup) => {
  const element = root.value;
  if (!element || props.disabled) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry?.isIntersecting && !props.loading) emit('load');
    },
    { rootMargin: '100px' },
  );
  observer.observe(element);
  onCleanup(() => observer.disconnect());
});
</script>

<template>
  <div
    v-if="hasMore"
    ref="root"
    class="flex justify-center"
  >
    <AppButton
      outline
      class="min-h-11"
      :loading="loading"
      :disabled="disabled"
      @click="emit('load')"
    >
      <slot>Показать ещё</slot>
    </AppButton>
  </div>
</template>
